export default __webpack_public_path__ + "static/media/driver_wait_confirm.57c89225.svg";